/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LeaveOrgPreflightResponseRole } from './leaveOrgPreflightResponseRole';

export interface LeaveOrgPreflightResponse {
  org_id: string;
  org_name: string;
  role: LeaveOrgPreflightResponseRole;
  owned_projects: number;
  managed_jobs: number;
  active_admins: number;
  requires_transfer: boolean;
  blocked_reason_code?: string | null;
  blocked_reason?: string | null;
}
